export default "__VITE_ASSET__8997df7c__"